<template>
    <div>
        <section class="banner-wrap" :class="'banner-wrap-'+platformName">
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="item in bannerList">
                        <a href="javascript:void(0)" @click="enterTo(item.url,item.name,'banner图')">
                            <img :src="item.picurl">
                        </a>
                    </div>
                </div>
            </div>
            <div class="swiper-pagination"></div>
        </section>
        <div class="theme-wrap">
            <!--<section class="adv-banner-wrap" :class="'adv-banner-wrap-'+platformName">-->
                <!--<p v-for="item in advBanner" v-html="item.name"></p>-->
            <!--</section>-->
            <section class="enter-wrap" :class="'enter-wrap-'+platformName">
                <ul>
                    <li v-for="item in enterList">
                        <a href="javascript:void(0)" @click="enterTo(item.url,item.name,'快速入口')">
                            <img :src="item.picurl" class="icon-vip">
                            <h5>{{item.name}}</h5>
                            <p v-html="item.summary"></p>
                        </a>
                    </li>
                </ul>
                <p class="pindan" @click="goPindan" style="display: none">拼单</p>
            </section>
        </div>

    </div>
</template>

<script>
    import Swiper from '../../../static/js/swiper-4.1.6.min.js'
    import {GetQueryString} from '../../resource/js/common'
    import {invokeApi} from '@/resource/js/GLOBAL2'
    import {sa} from '@/resource/js/ANALYSIS2'

    export default{
        data(){
            return {
            }
        },
        props:['platformName'],
        computed:{
            bannerList:function () {
                return this.$store.state.indexBanner.bannerList
            },
            advBanner:function () {
                return this.$store.state.indexBanner.advBanner
            },
            enterList:function () {
                return this.$store.state.indexBanner.enterList
            }
        },
        mounted(){
            this.initBanner();

        },
        methods:{
            initSwiper(){
                new Swiper('.swiper-container', {
                    autoplay:{
                        stopOnLastSlide:false
                    },
                    pagination:{
                        el:'.swiper-pagination'
                    },
                    observer:true,
                });
            },
            initBanner(){
                var _this= this;
                this.$store.dispatch('initSwiperBannerAdv').then(res=>{
                    _this.initSwiper()
                })

            },
            enterTo(url,name,from){
                sa.track('lcweb',{'lcclick':'首页_'+from+'_'+name});
                window.location.href = url
            },

            // 进入拼单入口
            goPindan() {
                invokeApi("/collage/checkCanJoinCollage", {
                    "inviteId": ''
                },"", Math.random(), (res) => {
                    // if(res.status == 4) { // 有未完成的拼单
                    //     window.location.href = '/pages/active/pindan/order_detail/order_detail.html?bindCode=' + res.bindCode + '&inviteId=' + res.inviteId;
                    // } else {
                        window.location.href = "/pages/active/pindan/pd_index/pd_index.html?bindCode=14d4644b7a8847f49bfcbc85c34d0a8a"
                    // }
                });

            }
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss">
    @import "../../resource/css/color";
    @import "../../resource/css/default";
    /*@import "../../resource/css/christmas-theme";*/
    @import "../../assets/css/swiper-4.1.6.min.css";
    .index-wrap{
        /**swiper**/
        .banner-wrap{
            position: relative;
        }
        .banner-wrap-lechun{
            margin-top:1.76rem;
        }

        .swiper-container {
            width: 7.5rem;
            height: 3.75rem;
        }

        .swiper-slide {
            display: block;
            width: 7.5rem;
            height: 3.75rem;
        }

        .swiper-isshow1, .swiper-isshow2 {
            display: none;
        }

        .swiper-slide img {
            width: 7.5rem;
            height: 3.75rem;
            display: block;
        }

        .swiper-pagination {
            position: absolute;
            bottom: 4%;
            left: 50%;
            z-index: 2;
            -webkit-transform: translateX(-50%);
        }

        .swiper-pagination-bullet, .swiper-pagination-switch {
            display: inline-block;
            width: .10rem;
            height: .10rem;
            border-radius: .07rem;
            margin: 0 .1rem;
            border: 1px solid #ffffff;
            opacity: 1;
            background: transparent;
        }

        .swiper-pagination-bullet-active, .swiper-active-switch {
            background: #ffffff;
        }
        .theme-wrap{
            background: $bannerIndex;
            background-size: 100% auto;

        }
        /**adv-banner**/
        .adv-banner-wrap{
            display: -webkit-box;
            -webkit-box-pack: justify;
            -webkit-box-align: center;
            box-sizing: border-box;
            color:$advBannerText;
            em{
                font-weight: bolder;
            }
        }
        .adv-banner-wrap-lechun{
            font-size: .2rem;
            padding: .2rem .33rem .1rem;
            em{
                /*color: #000000;*/
                color:$advBannerText;
            }
        }
        .adv-banner-wrap-mryq{
            font-size: .24rem;
            padding: .26rem .33rem;
            color: #828282;
            em{
                color: #828282;
            }
        }

        /**enter**/
        .enter-wrap {
            position: relative;
            ul {
                display: -webkit-box;
            }
            img {
                display: block;
                margin: 0 auto .05rem;
            }
            .pindan {
                position: absolute;
                border: 1px solid #e50011;
                color: #e50011;
                text-align: center;
                padding: 0rem .1rem;
                bottom: -.55rem;
                right: .24rem;
                border-radius: .06rem;
                background: #fbf4f4;
                z-index: 2;
            }
        }
        .enter-wrap-lechun{
            ul{
                padding: .2rem .1rem;
            }
            img {
                width: .8rem;
                height: .8rem;
            }
        }
        .enter-wrap-mryq{
            border-top: 1px solid #ececec;
            ul{
                padding: .29rem .1rem;
            }
            img {
                width: .82rem;
                height: .82rem;
            }
        }
        .enter-wrap li {
            position: relative;
            -webkit-box-flex: 1;
            width: 25%;
            text-align: center;
        }


        /*.enter-wrap i.icon-balance {*/
            /*background: url("../../pages/index/images/index-icon-balance.png") no-repeat;*/
            /*background-size: 100% auto;*/
        /*}*/

        /*.enter-wrap i.icon-activity {*/
            /*background: url("../../pages/index/images/index-icon-discount.png") no-repeat;*/
            /*background-size: 100% auto;*/
        /*}*/

        /*.enter-wrap i.icon-long {*/
            /*background: url("../../pages/index/images/index-icon-long.png") no-repeat;*/
            /*background-size: 100% auto;*/
        /*}*/

        /*.enter-wrap i.icon-vip {*/
            /*background: url("../../pages/index/images/index-icon-vip.png") no-repeat;*/
            /*background-size: 100% auto;*/
        /*}*/
        /*.enter-wrap i.icon-tuan {*/
            /*background: url("../../pages/index1/images/icon-tuan.png") no-repeat;*/
            /*background-size: 100% auto;*/
        /*}*/

        /*.enter-wrap i.icon-yq {*/
            /*background: url("../../pages/index1/images/icon-yq.png") no-repeat;*/
            /*background-size: 100% auto;*/
        /*}*/

        .enter-wrap h5 {
            font-size: .22rem;
            line-height: .44rem;
            font-weight: normal;
            color: $enterTitle;
            margin-bottom: -.05rem;
        }

        .enter-wrap p {
            font-size: .22rem;
            color: #333333;
        }

        .enter-wrap p b {
            font-weight: normal;
            color: #e50011;
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/index/swiper_adv_enter.vue